<template>
  <div class="quality-recommend" >

      <img :src="info.list_img" class="slide-image" style="width:100%;height:auto;max-width:100%;" />

    <!--<div class="title acea-row row-center-wrapper">
      <div class="line"></div>
      <div class="name">
        <span class="iconfont" :class="icon"></span>{{ name }}
      </div>
      <div class="line"></div>
    </div>-->

    <div v-for="(item, index) in info.list" :key="index"  v-bind:style="bgColor()">
      <img :src="item.img" v-if="item.img" class="slide-image" style="width:100%;height:auto;max-width:100%;" />
      <GoodList :good-list="item.list" v-if="item.list" :is-sort="false"></GoodList>
    </div>



  </div>
</template>
<style>
  .quality-recommend {background-color:#fff;}
  .goodList .item {
    background-color: unset;
  }
</style>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import { isWeixin } from "@utils/index";
import { getAreaGoodsList } from "@api/store";
import { mapGetters } from "vuex";
import { getHomeData, getShare, follow } from "@api/public";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { getUser,getUserOpenId, getMenuUser } from "@api/user";
export default {
  name: "HotNewGoods",
  components: {
    swiper,
    swiperSlide,
    GoodList
  },
  computed: mapGetters(["isLogin"]),
  props: {},
  data: function() {
    return {
      imgUrls: [],
      goodsList: [],
      name: "",
      icon: "icon-jingpintuijian",
      bg_color:'#666',
      info:"",
      RecommendSwiper: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {
    this.getIndexGroomList();
    this.setOpenShare();
  },
  methods: {
    bgColor:function(){
      return "background:#"+this.bg_color;
    },
    getIndexGroomList: function() {
      let that = this;
      let id = this.$route.params.id;
      console.log(id);
      getAreaGoodsList(id)
        .then(res => {
          that.info = res.data;
          that.bg_color = "#000";
          that.name = res.data.info.index_title;
          document.title =  res.data.info.index_title;
          //this.bgColor();
        })
        .catch(function(res) {
          this.$dialog.toast({ mes: res.msg });
        });
    },

    setOpenShare() {
      if (isWeixin()) {
        if(this.isLogin){

          getUser().then(res => {
            var href = location.href;

            href =
                    href.indexOf("?") === -1
                            ? href + "?spread=" + res.data.uid
                            : href + "&spread=" + res.data.uid;
            var nickname = res.data.nickname;


            getShare().then(res => {
              var data = res.data.data;
              var configAppMessage = {
                desc: '['+nickname+'邀请] '+data.synopsis,
                title: data.title,
                link: href,
                imgUrl: data.img
              };
              openShareAll(configAppMessage);
            });
          })
        }else{
          getShare().then(res => {
            var data = res.data.data;
            var configAppMessage = {
              desc: data.synopsis,
              title: data.title,
              link: location.href,
              imgUrl: data.img
            };
            openShareAll(configAppMessage);
          });
        }


      }
    }
  }
};
</script>
